import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type SubscribeToBatchJobsSubscriptionVariables = Types.Exact<{
  batchId?: Types.InputMaybe<Types.Scalars['uuid']['input']>;
}>;


export type SubscribeToBatchJobsSubscription = { __typename?: 'subscription_root', batch_jobs: Array<{ __typename?: 'batch_jobs', id: number, output?: object | null, status: string, updatedat?: string | null, updatedby?: string | null }> };


export const SubscribeToBatchJobsDocument = gql`
    subscription subscribeToBatchJobs($batchId: uuid) {
  batch_jobs(
    where: {batch_id: {_eq: $batchId}}
    order_by: {sequence: asc_nulls_last}
  ) {
    id
    output
    status
    updatedat
    updatedby
  }
}
    `;

/**
 * __useSubscribeToBatchJobsSubscription__
 *
 * To run a query within a React component, call `useSubscribeToBatchJobsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToBatchJobsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToBatchJobsSubscription({
 *   variables: {
 *      batchId: // value for 'batchId'
 *   },
 * });
 */
export function useSubscribeToBatchJobsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SubscribeToBatchJobsSubscription, SubscribeToBatchJobsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToBatchJobsSubscription, SubscribeToBatchJobsSubscriptionVariables>(SubscribeToBatchJobsDocument, options);
      }
export type SubscribeToBatchJobsSubscriptionHookResult = ReturnType<typeof useSubscribeToBatchJobsSubscription>;
export type SubscribeToBatchJobsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToBatchJobsSubscription>;